export function setPageMeta({
  title,
  description,
  image,
  url,
  keywords,
  jsonLd,
  documentTitle,
  robots,
}) {
  if (title) {
    document.title = documentTitle || `${title} | MindBlows`;
    setMetaTag('meta[name="title"]', "content", title);
    setMetaTag('meta[property="og:title"]', "content", title);
    setMetaTag('meta[name="twitter:title"]', "content", title);
  }

  if (description) {
    setMetaTag('meta[name="description"]', "content", description);
    setMetaTag('meta[property="og:description"]', "content", description);
    setMetaTag('meta[name="twitter:description"]', "content", description);
  }

  if (image) {
    setMetaTag('meta[property="og:image"]', "content", image);
    setMetaTag('meta[name="twitter:image"]', "content", image);
  }

  if (url) {
    setMetaTag('meta[property="og:url"]', "content", url);
    setMetaTag('meta[name="twitter:url"]', "content", url);
    setCanonical(url);
  }

  if (keywords && keywords.length) {
    setMetaTag('meta[name="keywords"]', "content", keywords.join(", "));
  }

  if (robots) {
    setMetaTag('meta[name="robots"]', "content", robots);
  }

  if (jsonLd) {
    setJsonLd(jsonLd);
  } else {
    clearJsonLd();
  }
}

function setCanonical(url) {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

function setJsonLd(payload) {
  clearJsonLd();
  const blocks = Array.isArray(payload) ? payload : [payload];
  blocks.filter(Boolean).forEach((block) => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-page-jsonld", "true");
    script.text = JSON.stringify(block);
    document.head.appendChild(script);
  });
}

export function clearJsonLd() {
  document
    .querySelectorAll("script[data-page-jsonld]")
    .forEach((node) => node.remove());
}

function setMetaTag(selector, attribute, value) {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    const isProperty = selector.includes("property=");
    const name = selector.match(/"(.*?)"/)[1];
    if (isProperty) {
      tag.setAttribute("property", name);
    } else {
      tag.setAttribute("name", name);
    }
    document.head.appendChild(tag);
  }
  tag.setAttribute(attribute, value);
}

export function upscaleOgImage(iconUrl) {
  if (!iconUrl) return iconUrl;
  if (iconUrl.includes("mzstatic.com")) {
    return iconUrl.replace(/\/\d+x\d+bb\./, "/512x512bb.");
  }
  if (iconUrl.includes("googleusercontent.com")) {
    return iconUrl.replace(/=s0-br30$/, "=w512-h512");
  }
  return iconUrl;
}
